/* eslint-disable react/jsx-props-no-spreading */
/**
 *
 * PanelQuestion
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import Markdown from 'marked-react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { getQuestionVisibility } from 'containers/Assessment/utils';
import SingleQuestion from './SingleQuestion';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    width: '100%',
    padding: '12px 32px',
    [theme.breakpoints.down('600')]: {
      width: '100%',
      padding: 20,
    },
  },
  wrapper: {
    backgroundColor: '#eeeeee',
  },
  title: {
    flex: 1,
    display: 'table-cell',
    verticalAlign: 'bottom',
    padding: '20px 16px 0 16px',
  },
}));

function PanelQuestion({ number, title, elements, surveyContextProps }) {
  const classes = useStyles();

  if (!elements) return null;

  return (
    <Grid item xs={12} className={classes.container}>
      <Grid container className={classes.wrapper}>
        {title && (
          <Grid item xs={12}>
            <Typography
              className={classes.title}
              variant="h6"
              color="textPrimary"
            >
              <Markdown isInline>{title}</Markdown>
            </Typography>
          </Grid>
        )}
        {elements
          .filter(el => getQuestionVisibility(el, surveyContextProps.answers))
          .map((el, index) => {
            const props = {
              ...el,
              number: number + index,
              withinPanel: true,
              surveyContextProps,
            };
            return <SingleQuestion key={el.name} {...props} />;
          })}
      </Grid>
    </Grid>
  );
}

PanelQuestion.propTypes = {
  surveyContextProps: PropTypes.object,
  elements: PropTypes.array,
  isMobile: PropTypes.bool,
  name: PropTypes.string,
  number: PropTypes.number,
  title: PropTypes.string,
};

export default PanelQuestion;
